import CustomSelect from "../../shared/CustomSelect";
import CustomInput from "../../shared/CustomInput";
import BorrowerApplication from "../../shared/BorrowerApplication";

const PersonalInformation = ({
  closePersonalInformation,
  activeIndex,
  handleNextStep,
  borrowerInfo,
  setBorrowerInfo,
  errors,
  loading,
  handleBack,
  isDisabled = true,
}) => {
  return (
    <BorrowerApplication
      closeBioInformation={closePersonalInformation}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      loading={loading}
      handleBack={handleBack}
      isDisabled={isDisabled}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a Borrower
      </p>
      <p className="text-[#000000] font-semibold text-[20px]">
        Borrower’s Personal information
      </p>
      <p className="text-[#5C5C5C] text-[14px] font-normal">
        Fill in borrower’s personal information
      </p>
      <div className="flex items-start gap-[20px] my-[10px]">
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="username"
          >
            Username
          </label>
          <CustomInput
            placeholder="Enter your username"
            type="text"
            value={borrowerInfo?.username}
            onChange={(e) =>
              setBorrowerInfo({
                ...borrowerInfo,
                username: e.target.value,
              })
            }
          />
          {errors.username && (
            <span className="text-red-500 text-[12px]">{errors.username}</span>
          )}
        </div>
      </div>
      <div className="flex items-start gap-[20px] my-[10px]">
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="email"
          >
            Email
          </label>
          <CustomInput
            placeholder="Enter your email"
            type="text"
            value={borrowerInfo?.email}
            onChange={(e) =>
              setBorrowerInfo({
                ...borrowerInfo,
                email: e.target.value,
              })
            }
          />
          {errors.email && (
            <span className="text-red-500 text-[12px]">{errors.email}</span>
          )}
        </div>
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="Phone Number"
          >
            Phone Number
          </label>
          <CustomInput
            placeholder="Enter your phone number"
            type="text"
            value={borrowerInfo?.phoneNumber}
            onChange={(e) =>
              setBorrowerInfo({
                ...borrowerInfo,
                phoneNumber: e.target.value,
              })
            }
          />
          {errors.phoneNumber && (
            <span className="text-red-500 text-[12px]">
              {errors.phoneNumber}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-start gap-[20px] my-[20px]">
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="Alternative Phone Number"
          >
            Alternative Phone Number
          </label>
          <CustomInput
            placeholder="Enter your alternative phone number"
            type="text"
            value={borrowerInfo?.altPhoneNumber}
            onChange={(e) =>
              setBorrowerInfo({
                ...borrowerInfo,
                altPhoneNumber: e.target.value,
              })
            }
          />
          {errors.altPhoneNumber && (
            <span className="text-red-500 text-[12px]">
              {errors.altPhoneNumber}
            </span>
          )}
        </div>
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="middle name"
          >
            Marital Status
          </label>
          <CustomSelect
            name="marital status"
            value={borrowerInfo?.maritalStatus}
            onChange={(e) =>
              setBorrowerInfo({
                ...borrowerInfo,
                maritalStatus: e.target.value,
              })
            }
            options={["Single", "Married"]}
          />
          {errors.maritalStatus && (
            <span className="text-red-500 text-[12px]">
              {errors.maritalStatus}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-start gap-[20px] my-[10px]">
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="Number of Dependents"
          >
            Number of Dependents
          </label>
          <CustomInput
            placeholder="Enter number of dependents"
            type="text"
            value={borrowerInfo?.dependants}
            onChange={(e) =>
              setBorrowerInfo({
                ...borrowerInfo,
                dependants: e.target.value,
              })
            }
          />
          {errors.dependants && (
            <span className="text-red-500 text-[12px]">
              {errors.dependants}
            </span>
          )}
        </div>
        <div className="flex w-[45%] flex-col">
          <label
            className="text-[#222222] font-medium text-[13px]"
            htmlFor="P.O Box"
          >
            P.O Box
          </label>
          <CustomInput
            placeholder="Enter P.O Box"
            type="text"
            value={borrowerInfo?.postalAddress}
            onChange={(e) =>
              setBorrowerInfo({
                ...borrowerInfo,
                postalAddress: e.target.value,
              })
            }
          />
          {errors.postalAddress && (
            <span className="text-red-500 text-[12px]">
              {errors.postalAddress}
            </span>
          )}
        </div>
      </div>
    </BorrowerApplication>
  );
};

export default PersonalInformation;
